const { __, _x, _n, _nx } = wp.i18n;

/**
 * Renders a use case selector for use case menus.
 * @param {Object} props
 * @param {string} props.selectedUseCase - The currently selected use case.
 * @param {function} props.selectUseCase - Gets called when a use case gets selected.
 * @param {string[]} props.useCases - All existing use cases.
 */

let UseCaseSelector = ( props ) => {
	var selected = parseInt( props.selectedUseCase );
	if ( ! Number.isNaN( selected )
		&& ! props.useCases.some( x => x.id === selected ) ) {
		props.selectUseCase("");
	}
	return (
		<>
			<label forname="use-case-selector">
				Use Case:
			</label>
			<select
				id="use-case-selector"
				className="custom-select custom-select-sm"
				value={selected||""}
				onChange={event => props.selectUseCase( event.target.value )}>
				<option key="all" value="">
					{__( "All", "iportal-core" )}
				</option>
				{
					props.useCases.map( ( useCase ) =>
						<option key={ useCase.id } value={ useCase.id }>
							{ useCase.label }
						</option>
					)
				}
			</select>
		</>
	);
};

export default UseCaseSelector;
